import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get province
export const getProvince = createAsyncThunk("province/getProvince", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getProvince({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all province
export const getAllProvince = createAsyncThunk("province/getAllProvince", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllProvince();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("province/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("province/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("province/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageProvince({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create province
export const createProvince = createAsyncThunk("province/createProvince", async (param, { rejectWithValue }) => {
  const { country, name, provinceId, isActive } = param;
  try {
    const body = JSON.stringify({ country, name, provinceId, isActive });
    const { data } = await API.createProvince(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateProvince = createAsyncThunk("province/updateProvince", async (param, { rejectWithValue }) => {
  const { id, values } = param;
  const { country, name, provinceId, isActive } = values;
  try {
    const body = JSON.stringify({ country, name, provinceId, isActive });
    const { data } = await API.updateProvince(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("province/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
